import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import moment from "moment";
import vSelect from "vue-select";
import { IPermission, ISlot } from "@/models";

@Component({
    name: "navbar-expedition",
    components: {
        "v-select": vSelect,
    },
})

export default class NavbarExpedition extends Vue {
    @Prop({ required: true, type: String })
    public title: string;

    @Prop({ required: false, type: String })
    public iconRoutePath: string;

    public readonly modalSettings: string = "modalSettings";

    public startSlot: ISlot;
    public endSlot: ISlot;

    public constructor() {
        super();

        this.startSlot = this.$store.state.expeditions.expeditionStartSlot;
        this.endSlot = this.$store.state.expeditions.expeditionEndSlot;
    }

    public get permission(): IPermission {
        return this.$store.state.user.permission;
    }

    public toggleFullScreen(): void {
        this.$store.dispatch("app/toggleFullScreen");
    }

    public async exportExpeditions(): Promise<void> {
        const exportResponse = await this.$store.dispatch("expeditions/exportExpeditions");
        const exportUrl = window.URL.createObjectURL(new Blob([exportResponse.data]));
        const exportLink = document.createElement("a");
        exportLink.href = exportUrl;
        exportLink.setAttribute("download", `Expeditions-${moment().format("YYYY-MM-DD")}.xlsx`);
        exportLink.click();
    }

    public updateSlots(): void {
        this.$store.dispatch("expeditions/updateExpeditionSlots", {
            startSlotId: this.startSlot.slotId,
            endSlotId: this.endSlot.slotId,
        });
        this.$modal.hide(this.modalSettings);
    }
}
